import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: True when the platform memory feature (USER_MEMORY_ENABLED) is on for
// this deployment, surfaced via /app-config (NSAI-4111). Gates whether the
// "Settings → Memory" tab is shown at all — replacing the retired client-side
// localStorage soft-launch flag. The per-user on/off preference is a separate
// concern handled with a toggle inside the tab. Mirrors useTokenUsageEnabled.
export const useUserMemoryEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isUserMemoryEnabled ?? false;
};
